import { actionPrefixer } from 'shared/utils/utils';

const prefix = actionPrefixer('ARBITER');

export const ARBITER_MSG_RECEIVED = prefix('ARBITER_MSG_RECEIVED');

export const arbiterMessageReceived = (payload:any) => ({
  type: ARBITER_MSG_RECEIVED,
  payload,
});

